<div class="login-container">
  <!-- Left Side - Image -->
  <app-left-ui [welcomeText]="'Let\'s get started'" [welcomeSubtitle]="'Sign up to discover real connections and meaningful matches—made simple and secure.'"></app-left-ui>

  <!-- Right Side - Form -->
  <div class="login-form relative">
    <div class="form-container" style="max-width: 480px; width: 100%;">
      <div class="form-header text-center">
        <!-- Squircle Icon matching email verification -->
        <div style="width: 60px; height: 60px; background: linear-gradient(45deg, #bc8710, #c1a407); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; box-shadow: 0 4px 10px rgba(188, 135, 16, 0.3);">
          <i class="fa-solid fa-lightbulb" style="color: #fff; font-size: 28px;"></i>
        </div>
        <h2 class="form-title" style="font-size: 24px; font-weight: 700; color: #1e293b; margin-bottom: 8px;">Let's get to know you</h2>
        <p class="form-subtitle mt-2" style="font-size: 14px; color: #64748b;">
          Please provide your personal details to start matching.
        </p>
      </div>

      <form #userDetailsForm="ngForm" (ngSubmit)="continueClick(userDetailsForm)" autocomplete="off" style="margin-top: 30px;">
        
        <!-- Row 1: First Name and Last Name -->
        <div class="form-row">
          <div style="flex: 1;">
            <label style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 8px;">First Name</label>
            <input
              type="text"
              name="firstName"
              class="form-control"
              [(ngModel)]="formData.firstName"
              required
              #firstName="ngModel"
              placeholder="First Name"
              style="border-radius: 12px; padding: 12px; border: 1px solid #ddd; box-shadow: none;" />
            <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
              <small *ngIf="firstName.errors?.['required']">First name is required.</small>
            </div>
          </div>

          <div style="flex: 1;">
            <label style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 8px;">Last Name</label>
            <input
              type="text"
              name="lastName"
              class="form-control"
              [(ngModel)]="formData.lastName"
              required
              #lastName="ngModel"
              placeholder="Last Name"
              style="border-radius: 12px; padding: 12px; border: 1px solid #ddd; box-shadow: none;" />
            <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
              <small *ngIf="lastName.errors?.['required']">Last name is required.</small>
            </div>
          </div>
        </div>

        <!-- Row 2: Age and Gender -->
        <div class="form-row">
          <div style="flex: 1;">
            <label style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 8px;">Age</label>
            <input
              type="number"
              name="age"
              class="form-control"
              [(ngModel)]="formData.age"
              required
              #age="ngModel"
              min="13"
              max="120"
              placeholder="Age"
              style="border-radius: 12px; padding: 12px; border: 1px solid #ddd; box-shadow: none;" />
            <div *ngIf="age.invalid && (age.dirty || age.touched)" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
              <small *ngIf="age.errors?.['required']">Age is required.</small>
              <small *ngIf="age.errors?.['min']">Must be at least 13.</small>
              <small *ngIf="age.errors?.['max']">Must be at most 120.</small>
            </div>
          </div>

          <div style="flex: 2;">
            <label style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 8px;">I am</label>
            <div style="display: flex; gap: 10px; height: 50px;">
              <button type="button" class="gender-btn" [class.active]="formData.gender === 'male'" (click)="setGender('male')">
                <i class="fa-solid fa-mars me-2"></i> Male
              </button>
              <button type="button" class="gender-btn" [class.active]="formData.gender === 'female'" (click)="setGender('female')">
                <i class="fa-solid fa-venus me-2"></i> Female
              </button>
              <button type="button" class="gender-btn" [class.active]="formData.gender === 'other'" (click)="setGender('other')">
                <i class="fa-solid fa-genderless me-2"></i> Other
              </button>
            </div>
            <input type="hidden" name="gender" [(ngModel)]="formData.gender" required #gender="ngModel" />
            <div *ngIf="gender.invalid && (userDetailsForm.submitted)" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
              <small>Gender is required.</small>
            </div>
          </div>
        </div>

        <!-- Row 3: Location -->
        <div style="margin-bottom: 24px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
            <label style="font-size: 13px; font-weight: 600; margin: 0;">Location</label>
            <button type="button" (click)="useCurrentLocation()" style="background: none; border: none; color: #bc8710; font-size: 12px; font-weight: 600; padding: 0;">
              <i class="fa-solid fa-location-crosshairs"></i> Use current location
            </button>
          </div>
          
          <div style="position: relative;">
            <i class="fa-solid fa-location-dot" style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%); color: #9ca3af;"></i>
            <input
              type="text"
              name="location"
              class="form-control"
              [(ngModel)]="formData.location"
              (input)="onLocationInput($event)"
              required
              #location="ngModel"
              #locationInput
              placeholder="Search Location"
              style="border-radius: 12px; padding: 12px 12px 12px 40px; border: 1px solid #ddd; box-shadow: none; width: 100%;" />
              
            <!-- Autocomplete Suggestions Dropdown -->
            <ul *ngIf="showSuggestions && locationSuggestions.length > 0" class="suggestions-list">
              <li *ngFor="let suggestion of locationSuggestions" (click)="selectLocation(suggestion)" class="suggestion-item">
                <i class="fa-solid fa-location-dot me-2 text-muted"></i>
                <span>{{ suggestion.description }}</span>
              </li>
            </ul>
          </div>
          <div *ngIf="location.invalid && (location.dirty || location.touched)" style="color: #ef4444; font-size: 12px; margin-top: 4px;">
            <small *ngIf="location.errors?.['required']">Location is required.</small>
          </div>
        </div>

        <button
          type="submit"
          class="login-btn w-100"
          [disabled]="isSubmitting"
          style="background: linear-gradient(45deg, #bc8710, #c1a407); border-radius: 12px; padding: 14px; font-weight: 600; font-size: 16px; border: none; color: white; box-shadow: 0 4px 10px rgba(188, 135, 16, 0.2);">
          <span *ngIf="!isSubmitting">Continue</span>
          <span *ngIf="isSubmitting"><i class="fa-solid fa-circle-notch fa-spin me-2"></i>Submitting...</span>
        </button>

        <div class="text-center mt-3">
          <p style="font-size: 11px; color: #94a3b8;">
            By continuing you agree to our <a routerLink="/terms" style="color: #94a3b8; text-decoration: underline;">Terms of Service</a> and <a routerLink="/privacy" style="color: #94a3b8; text-decoration: underline;">Privacy Policy</a>.
          </p>
        </div>

        <div class="text-center mt-4">
          <button type="button" (click)="logout()" style="background: none; border: none; color: #bc8710; font-weight: bold; font-size: 14px; text-decoration: none; cursor: pointer;">
            Logout
          </button>
        </div>
      </form>
    </div>
  </div>
</div>